var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.625,
    height: 87.687,
    viewBox: "0 0 75.625 87.687",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "not_Found",
    "data-name": "not Found",
    transform: "translate(-153.861 -158.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration_3",
    transform: "translate(153.861 158.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M-249.157,71.249v-.006A12.729,12.729,0,0,0-258.779,60.2l-.02-.007q-3.7-.892-7.465-1.424l-1.241-1.815a1.4,1.4,0,0,0-.732-.762,1.407,1.407,0,0,0-1.771.55c-.012.019-.022.039-.033.058a1.163,1.163,0,0,0-.061.105l-6.714,13.919a6.253,6.253,0,0,0-1.048-.088,6.247,6.247,0,0,0-1.048.088l-6.715-13.919c-.012-.025-.024-.051-.036-.076s-.027-.038-.039-.058l-.021-.033a1.407,1.407,0,0,0-1.844-.51,1.4,1.4,0,0,0-.646.713l-1.248,1.826q-3.765.535-7.466,1.424c-.021.005-.04.014-.061.021a12.724,12.724,0,0,0-9.582,11.028v0h0a180.218,180.218,0,0,0-.937,18.365h0a1.411,1.411,0,0,0,1.412,1.411,1.411,1.411,0,0,0,1.411-1.412,177.288,177.288,0,0,1,.924-18.079,9.9,9.9,0,0,1,7.5-8.591l.027-.009c1.516-.366,3.043-.68,4.579-.952l-2.194,3.209a1.4,1.4,0,0,0-.326.612,1.409,1.409,0,0,0,.823,1.621c.039.017.079.028.119.041s.069.028.107.037l4.337,1.088a1.43,1.43,0,0,0,.347.042h0a1.411,1.411,0,0,0,1.365-1.067,1.412,1.412,0,0,0-1.024-1.714l-2.373-.595,3.366-4.924,5.606,11.619a5.24,5.24,0,0,0-2.008,4.3,5.4,5.4,0,0,0,5.647,5.508,5.406,5.406,0,0,0,5.647-5.509,5.24,5.24,0,0,0-2.007-4.3l5.605-11.62,3.367,4.925-2.373.595a1.411,1.411,0,0,0-1.067,1.365,1.412,1.412,0,0,0,1.408,1.415,1.416,1.416,0,0,0,.345-.042l4.34-1.088c.021-.005.039-.016.059-.022s.027-.01.04-.015a1.386,1.386,0,0,0,.3-.143c.017-.011.038-.015.055-.027s.022-.02.034-.028l.038-.032a1.409,1.409,0,0,0,.3-1.9l-2.29-3.348c1.54.273,3.073.589,4.594.957l.009,0a9.9,9.9,0,0,1,7.5,8.587v0a177.788,177.788,0,0,1,.924,18.079h0a1.411,1.411,0,0,0,1.412,1.411,1.414,1.414,0,0,0,1.411-1.412A180.168,180.168,0,0,0-249.157,71.249Zm-28.706,7.683a2.6,2.6,0,0,1-2.823-2.685,2.6,2.6,0,0,1,2.823-2.685,2.6,2.6,0,0,1,2.823,2.685A2.6,2.6,0,0,1-277.864,78.931Z",
    transform: "translate(307.508 -19.992)",
    fill: "#454f63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M-273.561,30.379a15.132,15.132,0,0,0,5.328.969,15.279,15.279,0,0,0,5.386-.984l1.673-.762a15.041,15.041,0,0,0,7.92-11.677,22.256,22.256,0,0,0-.219-16.469c-2.46-5.09-7.482-7.8-14.524-7.847-7.432-.028-12.677,3.094-15.13,9.081-1.655,4.042-2.093,11.107-.1,14.89a15.025,15.025,0,0,0,8,12.05l1.641.746Zm-3.4-18.591c.112.14.25.323.37.484l.025.034a9.193,9.193,0,0,0,8.379,4.431,10.189,10.189,0,0,0,8.423-4,8.659,8.659,0,0,1,.6-.638c1.4,1.129,2.305,4.125,2.854,5.942l.075.251c-1.153,7.1-6.963,10.17-12.214,10.068-5.277-.1-10.967-3.407-11.841-10.553C-279.715,15.947-278.281,12.955-276.958,11.788Zm14.978-.943a7.525,7.525,0,0,1-6.228,2.985,6.561,6.561,0,0,1-5.992-3.216c-.725-.988-1.469-2-2.576-2a2.785,2.785,0,0,0-1.546.566,11.476,11.476,0,0,0-3.161,3.9A18.884,18.884,0,0,1-280.435,3.8c2-4.866,6.164-7.3,12.422-7.267,5.947.04,9.954,2.125,11.9,6.166a19.165,19.165,0,0,1,1.163,10.434,10.222,10.222,0,0,0-2.749-3.56C-259.667,8.232-260.776,9.484-261.98,10.845Z",
    transform: "translate(297.812 6.39)",
    fill: "#454f63"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_411",
    "data-name": "Ellipse 411",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(196.486 213.436)",
    fill: "#454f63"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    "data-name": "Line 118",
    y2: 15.226,
    transform: "translate(207.776 225.107) rotate(-45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_119",
    "data-name": "Line 119",
    y2: 15.226,
    transform: "translate(218.542 225.107) rotate(45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNotFound);
export default __webpack_public_path__ + "static/media/userNotFound.c8166aa0abe75b3428a14a1f0e2f4a6c.svg";
export { ForwardRef as ReactComponent };